import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

export default function GridLayout({ items, itemsPerRow }) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: `repeat(1, 1fr)`,
          lg: `repeat(${itemsPerRow}, 1fr)`,
        }, // Grid layout for large screens
        gap: 2, // MUI spacing system (16px equivalent)
      }}
    >
      {items.map((item, index) => (
        <Box
          key={index}
          sx={{
            width: "100%", // Ensure it takes the full available space in the grid column
            overflow: "hidden", // Hide any overflow content
            transition: "all 0.3s ease",
            aspectRatio: { xs: undefined, lg: 1 },
          }}
        >
          {item}
        </Box>
      ))}
    </Box>
  );
}

GridLayout.propTypes = {
  items: PropTypes.arrayOf(PropTypes.node).isRequired,
  itemsPerRow: PropTypes.number.isRequired,
};
